// window._ = require('lodash');
// window.axios = require('axios');
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
//window.axios.defaults.headers.common["Authorization"] = authBearer 
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN' : cstfToken
};

import Vue from 'vue';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import store from './store';

import VCalendar from 'v-calendar'
import { ModalPlugin, CardPlugin, CollapsePlugin, FormCheckboxPlugin } from 'bootstrap-vue';

Vue.use(VCalendar)
Vue.use(ModalPlugin)
Vue.use(CardPlugin)
Vue.use(CollapsePlugin)
Vue.use(FormCheckboxPlugin)
 
// Vue.config.devtools = false

Vue.prototype.destPage = destPage
Vue.prototype.strPage = strPage

const FormSearch = () => import(/* webpackChunkName: "form-search" */ './components/FormSearch.vue');


const app = new Vue({
    el: '#app',    
    store,
    components: {
        FormSearch
    }
});


window.startFxExt = function startActionExternal(vm) {
    $(".sfdestm").on("click touchstart",function(){ 
        var dates = null;
        let packs = null
        
        if ($(this).data("strcodes")) {

            if ($(this).data("from") && $(this).data("to"))
                dates = {
                  checkin: $(this).data("from"),
                  checkout: $(this).data("to")
                };

            if ($(this).data("rangefrom"))
                dates = { rangefrom: $(this).data("rangefrom") };

            if ($(this).data("packs")) {
                packs = $(this).data("packs")
            }

            vm.$emit("ext_openForm", $(this).data("strcodes"), dates, packs);
        }
    })

    // $(".open-form-search").on("click touchstart", function() {
    //     if (formactive != $(this).attr("href")) {
    //         $(".search-form").removeClass("invisible");
    //         $(".search-form .tab-content.hidden").addClass("active");
    //         formactive = $(this).attr("href");
    //         $(".search-nav-link").removeClass("active");
    //         $('.search-nav-link[href*="' + formactive + '"]').addClass(
    //             "active"
    //         );
    //         $(".search-form .tab-content .tab-pane").removeClass(
    //             "show active"
    //         );
    //         $(formactive).tab("show");
  
    //         if ($(".search-form .tab-content.hidden").hasClass("active")) {
    //             $("body").css({ "padding-top": $("navbar").height() });
    //             $("navbar")
    //                 .eq(0)
    //                 .css("box-shadow", "none");
    //         }
    //     }
  
    //     if ($(this).data("strcodes")) {
    //         var dates = null;
    //         let packs = null

    //         $([document.documentElement, document.body]).animate({
    //             scrollTop: $(".form-search").offset().top - 250
    //         }, 500, "swing");
  
    //         if ($(this).data("from") && $(this).data("to"))
    //             dates = {
    //                 checkin: $(this).data("from"),
    //                 checkout: $(this).data("to")
    //             };
  
    //         if ($(this).data("rangefrom"))
    //             dates = { rangefrom: $(this).data("rangefrom") };
                
    //         if ($(this).data("packs")) {
    //             packs = $(this).data("packs")
    //         }
  
    //         vm.$emit("ext_openForm", $(this).data("strcodes"), dates, packs);
    //     }
    // });
};

window.startFxExt(app)



